import dayjs, { Dayjs } from "dayjs"
import { DatePicker } from "@mui/x-date-pickers"
import TextField from "@mui/material/TextField"
import MenuItem from "@mui/material/MenuItem"
import DateRangeIcon from "@mui/icons-material/DateRange"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { useDispatch, useSelector } from "react-redux/es/exports"
import { RootState } from "../../../../../../app/store"
import React, { memo } from "react"
import { setInterviewDateState } from "../../dialogs/model/Interviews"
import Checkbox from "@mui/material/Checkbox"
import Box from "@mui/material/Box"
import { Divider, FormControlLabel, List } from "@mui/material"
import { keycloakInstance } from "../../../../../../shared/libs/keycloack/config"

const ResultateTab = memo(
  ({
    register,
    formState,
    selects,
    control,
    watch,
    setValue,
    clearErrors,
    resetField,
  }: any) => {
    const interviewRow = useSelector((state: RootState) => state.interviewRow)
    const interviewMode = useSelector((state: RootState) => state.interviewMode)
    const interviewDate = useSelector((state: RootState) => state.interviewDate)
    const dispatch = useDispatch()

    const isApprover = () => {
      return keycloakInstance.realmAccess?.roles.some((role) =>
        ["hiring-approver"].includes(role),
      )
    }

    return (
      <Stack direction={"row"} spacing={"40px"}>
        <Stack spacing={"5px"} sx={{ width: "480px" }}>
          <Typography sx={{ fontSize: 20, fontWeight: "bold" }}>
            Статус
          </Typography>
          {interviewMode.mode !== "edit" ? (
            <TextField
              disabled={interviewMode.mode === "create"}
              size="small"
              label="Выберите статус"
              inputProps={register("resultate.status")}
              value={watch("resultate.status")}
              id="outlined-select-currency"
              select
              onChange={() => {
                resetField("resultate.eliminationReason")
                resetField("resultate.eliminationStage")

              }}
              SelectProps={{
                value: watch("resultate.status"),
              }}
            >
              {selects?.interviewSchedule?.status?.map((option: any) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
          ) : (
            <TextField
              size="small"
              label="Выберите статус"
              inputProps={register("resultate.status")}
              value={watch("resultate.status")}
              id="outlined-select-currency"
              select
              onChange={() => {
                resetField("resultate.eliminationReason")
                resetField("resultate.eliminationStage")
              }}
              SelectProps={{
                value: watch("resultate.status"),
              }}
            >
              {interviewRow.statusSelect.map((option: any) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
          )}
          <Typography sx={{ fontSize: 14, fontWeight: "bold", pt: "40px" }}>
            Отсев
          </Typography>
          <TextField
            disabled={watch("resultate.status") !== 12}
            // сделать обязательными
            label="Этап отсева"
            size="small"
            placeholder="Этап отсева"
            inputProps={register("resultate.eliminationStage")}
            fullWidth
            value={watch("resultate.eliminationStage")}
            id="outlined-select-currency"
            select
          >
            {selects?.interviewSchedule?.eliminationStage.map((option: any) => (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            disabled={watch("resultate.status") !== 12}
            label="Причина отсева"
            size="small"
            placeholder="Причина отсева"
            inputProps={register("resultate.eliminationReason")}
            fullWidth
            value={watch("resultate.eliminationReason")}
            id="outlined-select-currency"
            select
          >
            {selects?.interviewSchedule.eliminationReason.map((option: any) => (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            ))}
          </TextField>
          <Typography sx={{ fontSize: 14, fontWeight: "bold", pt: "20px" }}>
            Дата отсева
          </Typography>
          <DatePicker
            disabled={watch("resultate.status") !== 12}
            slots={{
              openPickerIcon: DateRangeIcon,
            }}
            sx={{
              ".MuiIconButton-root": { color: "rgba(139, 139, 139, 1)" },
            }}
            value={
              interviewMode.mode === "edit"
                ? interviewRow.resultate.eliminationDate
                  ? dayjs(watch("resultate.eliminationDate"))
                  : null
                : interviewDate.eliminationDate
            }

            localeText={{
              toolbarTitle: "ЧЧ.ММ.ГГГГ",
              fieldDayPlaceholder: () => "ДД",
              fieldMonthPlaceholder: () => "ММ",
              fieldYearPlaceholder: () => "ГГГГ",
            }}
            onChange={(e: Dayjs | null) => {
              dayjs(e).isValid() &&
              clearErrors("resultate.eliminationDate")
              setValue(
                "resultate.eliminationDate",
                dayjs(e).format("YYYY-MM-DDTHH:mm:ssZ"),
              )
              dispatch(
                setInterviewDateState({
                  ...interviewDate,
                  eliminationDate: dayjs(e),
                }),
              )
            }}
            format="DD.MM.YYYY"
            slotProps={{
              textField: {
                inputProps: register("resultate.eliminationDate"),
                size: "small",
                variant: "outlined",
                placeholder: "ДД.ММ.ГГГГ",
              },
            }}
          />

          {interviewMode.mode === "edit" && isApprover() && (
            <List>
              <Typography sx={{ fontSize: 20, fontWeight: "bold", pt: "40px" }}>
                Оплата рекрутерам
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => {
                        setValue(
                          "paymentRecruiters.lineCame",
                          !watch("paymentRecruiters.lineCame"),
                        )
                      }}
                      checked={watch("paymentRecruiters.lineCame")}
                    />
                  }
                  label={
                    watch("paymentRecruiters.lineCame")
                      ? "Оплачено"
                      : "Не оплачено"
                  }
                />

                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography>Оформлен</Typography>
                  <DatePicker
                    slots={{
                      openPickerIcon: DateRangeIcon,
                    }}
                    sx={{
                      ".MuiIconButton-root": {
                        color: "rgba(139, 139, 139, 1)",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                      width: "155px",
                    }}
                    value={
                      interviewMode.mode === "edit"
                        ? interviewRow.paymentRecruiters.lineCameDate
                          ? dayjs(watch("paymentRecruiters.lineCameDate"))
                          : null
                        : interviewDate.lineCameDate
                    }
                    localeText={{
                      toolbarTitle: "ЧЧ.ММ.ГГГГ",
                      fieldDayPlaceholder: () => "ДД",
                      fieldMonthPlaceholder: () => "ММ",
                      fieldYearPlaceholder: () => "ГГГГ",
                    }}
                    onChange={(e: Dayjs | null) => {
                      dayjs(e).isValid() &&
                        clearErrors("paymentRecruiters.lineCameDate")
                      setValue(
                        "paymentRecruiters.lineCameDate",
                        dayjs(e).format("YYYY-MM-DDTHH:mm:ssZ"),
                      )
                      dispatch(
                        setInterviewDateState({
                          ...interviewDate,
                          lineCameDate: dayjs(e),
                        }),
                      )
                    }}
                    format="DD.MM.YYYY"
                    slotProps={{
                      textField: {
                        inputProps: register("paymentRecruiters.lineCameDate"),
                        size: "small",
                        variant: "outlined",
                        placeholder: "ДД.ММ.ГГГГ",
                      },
                    }}
                  />
                </Box>
              </Box>

              <Divider component="li" />
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => {
                        setValue(
                          "paymentRecruiters.registered",
                          !watch("paymentRecruiters.registered"),
                        )
                      }}
                      checked={watch("paymentRecruiters.registered")}
                    />
                  }
                  label={
                    watch("paymentRecruiters.registered")
                      ? "Оплачено"
                      : "Не оплачено"
                  }
                />
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography>Прошел обучение</Typography>
                  <DatePicker
                    slots={{
                      openPickerIcon: DateRangeIcon,
                    }}
                    sx={{
                      ".MuiIconButton-root": {
                        color: "rgba(139, 139, 139, 1)",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                      width: "155px",
                    }}
                    value={
                      interviewMode.mode === "edit"
                        ? interviewRow.paymentRecruiters.registeredDate
                          ? dayjs(watch("paymentRecruiters.registeredDate"))
                          : null
                        : interviewDate.registeredDate
                    }
                    localeText={{
                      toolbarTitle: "ЧЧ.ММ.ГГГГ",
                      fieldDayPlaceholder: () => "ДД",
                      fieldMonthPlaceholder: () => "ММ",
                      fieldYearPlaceholder: () => "ГГГГ",
                    }}
                    onChange={(e: Dayjs | null) => {
                      dayjs(e).isValid() &&
                        clearErrors("paymentRecruiters.registeredDate")
                      setValue(
                        "paymentRecruiters.registeredDate",
                        dayjs(e).format("YYYY-MM-DDTHH:mm:ssZ"),
                      )
                      dispatch(
                        setInterviewDateState({
                          ...interviewDate,
                          registeredDate: dayjs(e),
                        }),
                      )
                    }}
                    format="DD.MM.YYYY"
                    slotProps={{
                      textField: {
                        inputProps: register(
                          "paymentRecruiters.registeredDate",
                        ),
                        size: "small",
                        variant: "outlined",
                        placeholder: "ДД.ММ.ГГГГ",
                      },
                    }}
                  />
                </Box>
              </Box>
              <Divider component="li" />
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => {
                        setValue(
                          "paymentRecruiters.trainingCompleted",
                          !watch("paymentRecruiters.trainingCompleted"),
                        )
                      }}
                      checked={watch("paymentRecruiters.trainingCompleted")}
                    />
                  }
                  label={
                    watch("paymentRecruiters.trainingCompleted")
                      ? "Оплачено"
                      : "Не оплачено"
                  }
                />
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography>Вышел в линию</Typography>
                  <DatePicker
                    slots={{
                      openPickerIcon: DateRangeIcon,
                    }}
                    sx={{
                      ".MuiIconButton-root": {
                        color: "rgba(139, 139, 139, 1)",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                      width: "155px",
                    }}
                    value={
                      interviewMode.mode === "edit"
                        ? interviewRow.paymentRecruiters.trainingCompletedDate
                          ? dayjs(
                              watch("paymentRecruiters.trainingCompletedDate"),
                            )
                          : null
                        : interviewDate.trainingCompletedDate
                    }
                    localeText={{
                      toolbarTitle: "ЧЧ.ММ.ГГГГ",
                      fieldDayPlaceholder: () => "ДД",
                      fieldMonthPlaceholder: () => "ММ",
                      fieldYearPlaceholder: () => "ГГГГ",
                    }}
                    onChange={(e: Dayjs | null) => {
                      dayjs(e).isValid() &&
                        clearErrors("paymentRecruiters.trainingCompletedDate")
                      setValue(
                        "paymentRecruiters.trainingCompletedDate",
                        dayjs(e).format("YYYY-MM-DDTHH:mm:ssZ"),
                      )
                      dispatch(
                        setInterviewDateState({
                          ...interviewDate,
                          trainingCompletedDate: dayjs(e),
                        }),
                      )
                    }}
                    format="DD.MM.YYYY"
                    slotProps={{
                      textField: {
                        inputProps: register(
                          "paymentRecruiters.trainingCompletedDate",
                        ),
                        size: "small",
                        variant: "outlined",
                        placeholder: "ДД.ММ.ГГГГ",
                      },
                    }}
                  />
                </Box>
              </Box>
            </List>
          )}
        </Stack>

        <Stack spacing={"10px"} sx={{ width: "480px" }}>
          <Stack direction={"column"} spacing={"5px"}>
            <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
              Результаты тестирования
            </Typography>
            <Stack
              direction={"row"}
              spacing={"10px"}
              justifyContent={"space-between"}
            >
              <Stack
                sx={{ width: "100%" }}
                direction={"column"}
                spacing={"5px"}
              >
                <Typography sx={{ fontSize: 14 }}>Скорость печати</Typography>
                <TextField
                  size="small"
                  inputProps={register("resultate.printingSpeed")}
                  fullWidth
                  value={watch("resultate.printingSpeed")}
                  label="Результаты тестирования"
                  type="number"
                />
              </Stack>
              <Stack
                sx={{ width: "100%" }}
                direction={"column"}
                spacing={"5px"}
              >
                <Typography sx={{ fontSize: 14 }}> Грамматика</Typography>
                <TextField
                  size="small"
                  inputProps={register("resultate.grammar")}
                  fullWidth
                  value={watch("resultate.grammar")}
                  label="Результаты тестирования"
                  type="number"
                />
              </Stack>
            </Stack>
          </Stack>
          <Stack direction={"column"} spacing={"5px"}>
            <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
              Результаты собеседования
            </Typography>

            <TextField
              size="small"
              inputProps={register("resultate.interviewResults")}
              fullWidth
              value={watch("resultate.interviewResults")}
              label="Результаты собеседования"
              multiline
              maxRows={4}
            />
          </Stack>
          <Stack direction={"column"} spacing={"5px"}>
            <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
              Результаты обучения
            </Typography>

            <TextField
              label="Специалист обучения"
              size="small"
              inputProps={register("resultate.training")}
              fullWidth
              value={watch("resultate.training")}
              select
            >
              {selects?.interviewSchedule?.training.map((option: any) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>

            <Stack
              alignItems={"center"}
              justifyContent={"center"}
              direction={"row"}
              spacing={"5px"}
            >
              <DatePicker
                slots={{
                  openPickerIcon: DateRangeIcon,
                }}
                sx={{
                  ".MuiIconButton-root": { color: "rgba(139, 139, 139, 1)" },
                }}
                value={
                  interviewMode.mode === "edit"
                    ? interviewRow.resultate.trainingResults.startDate
                      ? dayjs(watch("resultate.trainingResults.startDate"))
                      : null
                    : interviewDate.trainingResultsStartDate
                }
                localeText={{
                  toolbarTitle: "ЧЧ.ММ.ГГГГ",
                  fieldDayPlaceholder: () => "ДД",
                  fieldMonthPlaceholder: () => "ММ",
                  fieldYearPlaceholder: () => "ГГГГ",
                }}
                onChange={(e: Dayjs | null) => {
                  dayjs(e).isValid() &&
                    clearErrors("resultate.trainingResults.startDate")
                  setValue(
                    "resultate.trainingResults.startDate",
                    dayjs(e).format("YYYY-MM-DDTHH:mm:ssZ"),
                  )
                  dispatch(
                    setInterviewDateState({
                      ...interviewDate,
                      trainingResultsStartDate: dayjs(e),
                    }),
                  )
                }}
                format="DD.MM.YYYY"
                slotProps={{
                  textField: {
                    inputProps: register("resultate.trainingResults.startDate"),
                    size: "small",
                    variant: "outlined",
                    placeholder: "ДД.ММ.ГГГГ",
                  },
                }}
              />
              <div
                style={{
                  width: "10px",
                  height: "1px",
                  background: "#CACACA",
                  borderRadius: 4,
                }}
              />
              <DatePicker
                slots={{
                  openPickerIcon: DateRangeIcon,
                }}
                sx={{
                  ".MuiIconButton-root": { color: "rgba(139, 139, 139, 1)" },
                }}
                defaultValue={null}
                value={
                  interviewMode.mode === "edit"
                    ? interviewRow.resultate.trainingResults.endDate
                      ? dayjs(watch("resultate.trainingResults.endDate"))
                      : null
                    : interviewDate.trainingResultsEndDate
                }
                localeText={{
                  toolbarTitle: "ЧЧ.ММ.ГГГГ",
                  fieldDayPlaceholder: () => "ДД",
                  fieldMonthPlaceholder: () => "ММ",
                  fieldYearPlaceholder: () => "ГГГГ",
                }}
                onChange={(e: Dayjs | null) => {
                  dayjs(e).isValid() &&
                    clearErrors("resultate.trainingResults.endDate")
                  setValue(
                    "resultate.trainingResults.endDate",
                    dayjs(e).format("YYYY-MM-DDTHH:mm:ssZ"),
                  )
                  dispatch(
                    setInterviewDateState({
                      ...interviewDate,
                      trainingResultsEndDate: dayjs(e),
                    }),
                  )
                }}
                format="DD.MM.YYYY"
                slotProps={{
                  textField: {
                    inputProps: register("resultate.trainingResults.endDate"),
                    size: "small",
                    variant: "outlined",
                    placeholder: "ДД.ММ.ГГГГ",
                  },
                }}
              />
            </Stack>
            <TextField
              size="small"
              inputProps={register("resultate.trainingResults.result")}
              fullWidth
              value={watch("resultate.trainingResults.result")}
              label="Результаты обучения"
              multiline
              maxRows={4}
            />
          </Stack>

          <Stack direction={"column"} spacing={"5px"}>
            <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
              Результаты аттестации
            </Typography>
            <TextField
              size="small"
              inputProps={register(
                "resultate.certificationResults.testResultPercent",
              )}
              fullWidth
              value={watch("resultate.certificationResults.testResultPercent")}
              label="Результаты аттестации"
              multiline
              maxRows={4}
            />
            <Stack sx={{ width: "100%" }} direction={"row"} spacing={"10px"}>
              <Stack
                sx={{ width: "100%" }}
                direction={"column"}
                spacing={"5px"}
              >
                <Typography sx={{ fontSize: 14 }}>IQS</Typography>
                <TextField
                  size="small"
                  inputProps={register("resultate.certificationResults.iqs")}
                  fullWidth
                  value={watch("resultate.certificationResults.iqs")}
                  label="Введите баллы"
                  type="number"
                />
              </Stack>
              <Stack
                sx={{ width: "100%" }}
                direction={"column"}
                spacing={"5px"}
              >
                <Typography sx={{ fontSize: 14 }}> Результаты теста</Typography>
                <TextField
                  size="small"
                  inputProps={register(
                    "resultate.certificationResults.testResults",
                  )}
                  fullWidth
                  value={watch("resultate.certificationResults.testResults")}
                  label="Результаты теста в %"
                  type="number"
                />
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    )
  },
)

export default ResultateTab
